<template>
  <BaseGridView
    endpoint="v1/ContactPerson/GetData"
    :pageTitle="$t('Contact Persons')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
    :templateDef="templateDef"
  >
    <template #contactPerson_isActive="{ rowData }">
      <span
        :class="rowData.value ? 'badge text-bg-success' : 'badge text-bg-danger'"
      >
        {{ rowData.value ? "Active" : "Inactive" }}
      </span>
    </template>
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: [
    "company.Name",
    "firstName",
    "lastName",
    "emailAddress",
    "createdDateTimeOffset",
    "lastChangedDateTimeOffset",
    "title",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const templateDef: TemplateDef = {
  prefix: "contactPerson",
  columnNames: ["isActive"],
};

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
      width: 200,

    },
    { field: "firstName", headerText: instance?.$t("firstName") },
    { field: "lastName", headerText: instance?.$t("lastName") },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "contactPerson_isActive",
    },
    { field: "emailAddress", headerText: instance?.$t("emailAddress") },
    {
      field: "createdDateTimeOffset",
      headerText: instance?.$t("createdDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    {
      field: "lastChangedDateTimeOffset",
      headerText: instance?.$t("lastChangedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "title", headerText: instance?.$t("title") },
  ];
};
</script>
